<template>
  <div>
    <h5>
      Imagens
    </h5>
    <InputFileCustom v-model="itemData" />
  </div>
</template>

<script>
import { avatarText } from '@core/utils/filter'
import {onMounted, ref, watch, watchEffect} from '@vue/composition-api'
import useProdutosList from '@/views/apps/produtos/list/useProdutosList'
import InputFileCustom from '@/components/InputFileCustom.vue'

export default {
  components: {
    InputFileCustom,
  },
  model: {
    prop: 'itemData',
    event: 'handleSubmit',
  },
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { resolveUserRoleVariant } = useProdutosList()

    const imagens = ref(props.itemData.imagens)
    onMounted(() => {
      props.itemData.imagens = props.itemData.imagens.map(item => {
        if (item.caminho_imagem) {
          return { ...item, base64: null }
        }
        return { file: item.file, nome: item.nome, base64: null }
      })
    })

    return {
      resolveUserRoleVariant,
      avatarText,
      imagens,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
